<template>
  <div>
    <div class="banner">
      <div class="EC_width">
        <div class="display_between">
          <div class="leftBan">
            <img src="/image/jigou/detailHead.png">
            <p class="name">祝墡珠</p>
            <p class="signName">教授</p>
            <div class="showInfor">
              <img src="/image/quanke/inforImg.png"
                   class="marginRight5"><span>100</span>
              <img src="/image/quanke/xianshiImg.png"
                   class="marginLeft20 marginRight5"><span>1000</span>
            </div>
            <div class="btnWrap">
              <a href="javascript:void(0);"
                 class="headbtn">+订阅</a>
              <a href="javascript:void(0);"
                 class="headbtn headbtnRed">个人名片</a>
              <a href="javascript:void(0);"
                 class="headbtn headbtnBlue">发送站内信</a>
            </div>
          </div>
          <div class="rightBan">
            <img src="/image/quanke/signbg.png"
                 class="signBg">
            <a href="javascript:void(0);">
              <img src="/image/quanke/fanhui.png"
                   style="vertical-align: -6px;">
              <span class="marginLeft5">返回个人中心</span>
            </a>
            <p class="rightTitle">海峡两岸医药隆重交流协会全科医学分会会长</p>
            <p>学术专长：心血管相关疾病。</p>
            <div class="border_bottom_18">
            </div>
            <div class="titleContent">
              复旦大学上海医学院全科医学系教授 ；
              WONCA亚太区常委；《中华全科医师杂志》总编；国家全科医学师资培训示范基地学术委员会主任；中国医师协会全科医生教育培训专家委员会副主任；国家卫计委全科医生培训“十三五”规划教材评审委员会主任委员；国家卫健委基层卫生培训“十三五”规划教材评审委员会主任委员；中华医学会全科医学分会名誉主任委员；高等教育上海市级教学成果特等奖、教育部教学成果二等奖（第一完成人）；上海市住院医师规范化培训杰出贡献奖、宝钢教育基金优秀教师特等奖。WONCA亚太区五星级医生；第三届“国之名医—卓越建树”。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="border_bottom_18  marginTop40 marginBottom20 display_between">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          TA的动态
        </div>
        <div>
          返回个人主页>>
        </div>
      </div>
      <div class="display_between"
           v-for="(item,index) in apiData"
           :key="index">
        <div class="leftArticle">
          <div class="artTitle">
            {{item.title}}
          </div>
          <p><span class="fontBold">【中文期刊】</span>{{item.author}}</p>
          <p><span class="fontBold">《中国心血管病研究》</span>{{item.periods}}</p>
          <p><span class="fontBold">【摘要】</span>{{item.abstract}}</p>
          <p class="fontBold">【关键词】{{item.keyWords}} </p>
        </div>
        <div class="rightBtn">
          <a href="javascript:void(0);"
             class="zbtn">在线阅读</a>
          <a href="javascript:void(0);"
             class="zbtn">全文下载</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "expertLiterature",
  data () {
    return {
      apiData: "",
    }
  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.expertLiterature.data;
      })
    },
  },
  mounted () {
    this.getData()
  }
}
</script>

<style scoped>
.wrap {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 60px;
}
.qk_head {
    height: 77px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.pub_left_logo {
    width: 420px;
}

.pub_center_menu {
    flex: 1;
    height: 100%;
}

.pub_menu {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    height: 100%;
}

.pub_menu li {
    float: left;
    height: 100%;
    line-height: 77px;
}

.pub_menu li a {
    padding: 0 20px;
}

.pub_menu_active a {
    color: #0b8686;
}

.pub_right_opra {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inputRelative {
    position: relative;
    display: inline-block;
}

.pub_head_bar_search {
    width: 200px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 24px;
    outline: none;
    border: 1px solid #ddd;
    padding-left: 12px;
}

.inputRelative img {
    position: absolute;
    right: 11px;
    top: 3px;
    cursor: pointer;
}

.pub_mes_img {
    margin: 0 20px;
}

.pub_bar_headimg {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    overflow: hidden;
    line-height: 24px;
    text-align: center;
    border: 1px solid #ddd;
}

/* 面包屑导航 */
.breadcrumb_wrap {
    min-width: 1300px;
    list-style: none;
    height: 40px;
    background: #f2f2f2;
    display: flex;
}
.set_breadcrumb {
    list-style: none;
    line-height: 40px;
    height: 100%;
    padding: 0;
}
.set_breadcrumb li {
    display: inline-block;
    font-size: 12px;
    color: #0b8485;
}
.set_breadcrumb li ~ li:before {
    content: '>';
    margin-left: 4px;
    margin-right: 4px;
    color: #333;
}
.set_breadcrumb li a {
    display: inline-block;
    font-size: 12px;
    color: #333;
}
.breadcrumb_search input {
    width: 200px;
    height: 30px;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    outline: none;
    border: 1px solid #f2f2f2;
    padding-left: 10px;
}
.ArrIcon {
    display: inline-block;
    width: 50px;
    height: 30px;
    background: #0b8686;
    border-radius: 0 30px 30px 0;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}
.blocknext,
.blockpre {
    display: inline-block;
    width: 16px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    box-sizing: border-box;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 10px;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.blocknext {
    right: 0;
}
.blockpre {
    left: 0;
}
/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 40%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.nextbutton2,
.prevbutton2 {
    top: 40%;
}
.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.banner {
    padding-top: 80px;
    height: 526px;
    background: url(/image/quanke/bannernew.png) center no-repeat;
    box-sizing: border-box;
}

.leftBan {
    left: 195px;
    margin-top: -130px;
}

.name {
    font-size: 26px;
    color: #ffffff;
    font-weight: bold;
    text-align: center;
}

.signName {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
}

.showInfor {
    width: 195px;
    height: 36px;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
    color: #fff;
}

.rightBan {
    background: url(/image/quanke/bgTop.png) center no-repeat;
    width: 1005px;
    height: 412px;
    position: relative;
    padding-left: 67px;
    padding-right: 88px;
    box-sizing: border-box;
    padding-top: 34px;
}

.signBg {
    position: absolute;
    top: -47px;
    right: 76px;
}

.signBtnRed {
    display: inline-block;
    width: 130px;
    height: 30px;
    background: #df0018;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    color: #ffffff;
}
.signBtnblue {
    display: inline-block;
    width: 130px;
    height: 30px;
    background: #dff3f4;
    border: 1px solid #0b8586;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    color: #0b8586;
}
.rightTitle {
    color: #0b8586;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 19px;
}
.titleContent {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    margin-top: 20px;
}
.grayBg {
    background: #f6f7fb;
    padding: 60px 0;
}
.leftCanvas {
    flex: 1;
}
.rightList {
    width: 516px;
    height: 340px;
    overflow: auto;
    margin-left: 60px;
}
.headbtn {
    display: block;
    width: 160px;
    height: 30px;
    background: #ffffff;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
    margin-bottom: 10px;
}
.headbtnRed {
    background: #df0019;
    color: #fff;
}
.headbtnBlue {
    background: #003157;
    color: #fff;
}
.listCourse {
    height: 158px;
    overflow-y: auto;
}
.rightList::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}

/* 滚动槽 */
.rightList::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.rightList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}
.listCourse::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}

/* 滚动槽 */
.listCourse::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.listCourse::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}

.listCourse::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
.listitem {
    margin-top: 16px;
}
.listitem:hover {
    color: #0b8485;
    cursor: pointer;
}
.leftArticle {
    padding-bottom: 20px;
    border-bottom: 1px solid #ddd;
}
.artTitle {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 58px;
}
.leftArticle p {
    margin-bottom: 10px;
}
.zbtn {
    display: inline-block;
    width: 161px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #0b8586;
    border-radius: 3px;
    text-align: center;
    line-height: 36px;
    margin-bottom: 10px;
}
.zbtn:hover {
    background: #0b8586;
    color: #fff;
}
.rightBtn {
    margin-left: 90px;
}
</style>
